// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"77084ec4","489":"9d5f61c9","607":"02edfb7d","816":"bb365330"}[chunkId] + ".chunk.css";
};